<!-- prettier-ignore -->

@if(item && defaultFileImgName()){
  <div class="card" [ngClass]="{ 'card--is-category-list': isCategoryList }">
    @if(showTimeIcon(item)){
      <div class="time">
        <time-icon /> {{ item.durationc }}
      </div>
    }

    @if(showOfferIcon(item)){
      <div class="time">
        <offer-icon />
        {{ item.offers.length }}
      </div>
    }
  
    <div style="display: block;  width: 100%; height: 65%; overflow: hidden; position: relative; " >
      @if(showFavouriteIcon(item)){
        <div (click)="setFavourite(item)" class="love-icon">
          <favourite-icon [favourite]="isFavourite(item)" />
        </div>
      }

      <cicerone-lazy-image class="cicerone-lazy-image" 
        (click)="goToDetails(item)" 
        [url]="item.image" 
        [defaultFileImgName]="defaultFileImgName()"
        [urlFallback]="item.imageFallback" 
        [altImage]="item?.name?.[translate.currentLang]" 
      />
    </div>
  
    <div (click)="goToDetails(item)" class="infoPointContainer">
  
      @if(!isPdfCheckbox){
        <div class="cardInfoCar" style="width: 100%" [ngClass]="{'tech-selected' : isTechItemSelected(item)}">
          <div style=" display: flex; flex-direction: column; height: 90%; margin-top: 1%; justify-content: space-between; width: 100%;">
            <span class="textPOI">{{ item.name[translate.currentLang] }}</span>
            <div class="numClicksContainer">
              <span class="numClicks" >
                <ion-icon name="eye" style="margin-right: 5px; position: relative; bottom: 1px;"></ion-icon>
                {{ item.num_clicks }}
              </span>

              @if(isNumber(item.distance)){
                <span class="numClicks">
                  <ion-icon name="pin-outline"></ion-icon>
                  <span style="margin-right: 2px">{{ "a" | translate }}</span>
                  {{ item.distanceM }}
                </span>
              }

            </div>
          </div>
    
          @if(tools.isTechMode() && (item.type == 'pdf' || checkItemToRoute(item))){
            <div style=" min-width: 38px; display: flex; height: 100%; align-items: center; flex-direction: row; justify-content: flex-end; margin-left: 5px;">
              @if(item.type === 'pdf'){
                <ion-icon class="plusHome" name="eye" ></ion-icon>
              }
              @if(checkItemToRoute(item)){
                <ion-icon (click)="setTechItem($event, item)" class="plusHomeItem" [ngClass]="{'isTechItemSelected' : isTechItemSelected(item)}" name="add-outline" ></ion-icon>
              }
            </div>
          }
        </div>
      }

      @if(isPdfCheckbox){
        <div class="cardSelectPdf">
          <span class="textPdf">{{ item.name[translate.currentLang] }}</span>
          <ion-icon (click)="emitPdf($event, item.id)" class="plusPdfItem" name="add-outline" [ngClass]="{'transition': isSelected}"></ion-icon>
        </div>
      }

    </div>
  </div>
}

<!-- @if(seeMore){
  <div class="card">
    <span class="card__see-more">{{'Ver más' | translate}}</span>
  </div>
} -->